module.exports = __webpack_public_path__ + "img/presscoins-add-coin.9e9a1426.png";